import { useEffect, useState } from "react";
import axios from "axios";
import { Event, EventResponsibility } from "interfaces/events";
import ResponsibilityBox from "./ResponsibilityBox";

const Responsibilities = () => {
  const [responsibilities, setResponsibilities] = useState<EventResponsibility[]>([]);
  const [events, setEvents] = useState<Event[]>([]);

  useEffect(() => {
    axios
      .get<EventResponsibility[]>("/events/member-responsibility/get_blmember_event_responsibility/")
      .then(response => setResponsibilities(response.data));
  }, []);

  useEffect(() => {
    const fetchEvents = async () => {
      const eventIds = responsibilities.map(r => r.event);
      const response = await axios.get<Event[]>(`/events/all-events/?event_ids=${eventIds.join(",")}`);
      setEvents(response.data);
    };

    if (responsibilities.length > 0) {
      fetchEvents();
    }
  }, [responsibilities]);

  return (
    <>
      {responsibilities.map(responsibility => {
        const event = events.find(ev => ev.id === responsibility.event);
        if (!event) return null;
        return (
          <ResponsibilityBox
            key={responsibility.id}
            event={event}
            company={event.company}
            date={event.start}
            responsibility_type={responsibility.responsibility_type}
          />
        );
      })}
    </>
  );
};

export default Responsibilities;
